import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
 
@Injectable()
export class UserPrivilegesEventEmitterService {
    isEditHasWebAccess$ = new Subject();
}